import styled from 'styled-components';
import {
  gridContainer,
  setGridColumns,
  getColor,
  mq,
  getSpace
} from '../../../../stylesheets/tools';

const StyledEducationLibraryFilter = styled.div`
  padding-bottom: ${getSpace('xxxl')};

  .library {
    ${mq('l')} {
      ${gridContainer()}
      ${setGridColumns('1fr', 12)}
      gap: 60px;
    }

    .library__head {
      padding: 20px 0;
      margin-bottom: 30px;
      border-bottom: 1px solid;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .library__head-icon {
        color: ${getColor('darkGray')};
      }
    }

    .library__sidebar {
      ${mq('l')} {
        grid-column: span 3 / span 3;
        display: block;
      }
    }

    .library__exercises {
      ${mq('l')} {
        grid-column: span 9 / span 9;
      }
      .library__modal-icon-open {
        color: black;
      }
    }
    .library__filter-modal {
      &:not(.modal--open) {
        display: none;
      }

      &.modal--open {
        position: fixed;
        inset: 0;
        z-index: 99;
        background-color: white;
        overflow: auto;

        .library__filter-modal-inner {
          padding: 20px;
          position: absolute;
          width: 100%;
        }
      }
    }
  }
`;

export default StyledEducationLibraryFilter;
